import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface RunsheetAddDetailModalProps {
    scheduleId: number;
    showModal: boolean;
    hideModal(): void;
    save(unitNumber: string, rowVersionTimestamp: Uint8Array): void;
}

const RunsheetAddDetailModalData = (props: RunsheetAddDetailModalProps) => {
    const [loading, setLoading] = React.useState(true);
    const [unitNumber, setUnitNumber] = React.useState("");
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        if (props.scheduleId > 0 && props.showModal) {
            getData();
        }
    }, [props.scheduleId]);

    const getData = async () => {
        const token = await authService.getAccessToken();
        
        axios.get('api/RunSheet/GetJobDetail?ScheduleId=' + props.scheduleId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setUnitNumber(res.data);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const validate = () => {
        var formIsValid = true;
        let errorList: any = {};

        //remove spaces, fullstops and spaces
        var unitToCheck = unitNumber.replace(/[.,\s]/g, '');
        if (unitToCheck.length < 4) {
            formIsValid = false;
            errorList["unitNumber"] = "Unit Number must be at least 4 characters (no spaces, fullstops, commas)!";
        }

        setErrors(errorList);
        setUnitNumber(unitToCheck);
        return formIsValid;
    }
    

    const saveModal = () => {
        var formIsValid = validate();
        if (formIsValid) {
            saveJobDetails();
        } else {
            toast.error("Enter unit number (at least 4 characters) before saving!");
        }
    }

    const saveJobDetails = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var data = {
            scheduleId: props.scheduleId,
            unitNumber: unitNumber,
            subId: user.sub
        };

        axios.post('api/Runsheet/SaveJobDetail', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Job updated successfully");
                props.save(unitNumber, res.data.rowVersionTimestamp);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    return (
        <Modal static size={'lg'} aria-labelledby="contained-modal-title-sm" show={props.showModal} onHide={props.hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Update Job Details</Modal.Title>
                <button type="button" className="close" onClick={props.hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div className={loading ? "hidden" : "" }>
                    <label className="input-group" htmlFor="unitNumber">
                        <span className="label">Unit Number</span>
                        <input className="input" type="text" maxLength={50} id="unitNumber" name="unitNumber" value={unitNumber} onChange={(e) => setUnitNumber(e.target.value)}></input>
                    </label>
                    <span className={errors["unitNumber"] ? "label errors marginLeft5" : "hidden"}>{errors["unitNumber"]}</span>
                </div>
                <div className={loading ? "" : "hidden"}>Loading...</div>
            </Modal.Body>

            <Modal.Footer>
                <button className="popup-button--yes" onClick={saveModal}>Save</button>
            </Modal.Footer>
        </Modal>
    );

}

export default RunsheetAddDetailModalData;